module.exports = __webpack_public_path__ + "static/media/Generative Mode of Governance Script_1655370477807.0e743168.docx";